import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    Card
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import EyeSvg from '/public/site-assets/svg/eye.svg';
import MountainSvg from '/public/site-assets/svg/mountain.svg';

export default function TwoColumns({
    global,
    pathPrefix,
    customClass = "",
    heading,
    subheading,
    content1,
    content2
}) {

    return (
        <>
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <div className="text-center mb-5">
                        <h2>
                            <SourceFlowText global={global} path={`${pathPrefix}.heading`}>
                                {heading}
                            </SourceFlowText>
                        </h2>
                        <div>
                            <SourceFlowText global={global} path={`${pathPrefix}.subheading`}>
                                {subheading}
                            </SourceFlowText>
                        </div>
                    </div>
                    <Row>
                        <Col lg={6} className="position-relative mb-4 mb-lg-0">
                            <Card className="content-wrapper rounded-3 p-3 p-md-5 mb-4 mb-md-0 h-100">
                                <div className='mb-4 icon'>
                                    <span className='d-inline-block p-3'><EyeSvg /></span>
                                </div>
                                <SourceFlowText global={global} path={`${pathPrefix}.content1`} type="html">
                                    {content1}
                                </SourceFlowText>
                            </Card>
                        </Col>
                        <Col lg={6} className="position-relative mb-4 mb-lg-0">
                            <Card className="content-wrapper rounded-3 p-3 p-md-5 mb-4 mb-md-0 h-100">
                                <div className='mb-4 icon'>
                                    <span className='d-inline-block p-3'> <MountainSvg /></span>
                                </div>
                                <SourceFlowText global={global} path={`${pathPrefix}.content2`} type="html">
                                    {content2}
                                </SourceFlowText>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}